const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  filter: "All",
  search:''
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    filterSelect: (state, action) => {
      state.filter = action.payload;
    },
    filterSearch: (state, action) => {
      state.search = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { filterSelect, filterSearch } = filterSlice.actions;
